{
  "pia": {
    "dbVersion": 201707071818,
    "tableName": "pia",
    "serverUrl": null,
    "numberOfQuestions": 36,
    "created_at": "2018-02-20T15:25:41.845Z",
    "id": 12,
    "objectStore": {},
    "status": 3,
    "name": "Captoo",
    "author_name": "Elisabeth York",
    "evaluator_name": "Eric Vincent",
    "validator_name": "Mary Smith",
    "dpo_status": 1,
    "dpo_opinion": "L’analyse menée montre qu’avec la mise en place des plans d’actions préconisés, la protection de la vie privée des personnes est garantie de manière acceptable.",
    "concerned_people_opinion": "Le panel de clients interrogé lors de l'étude de marché est majoritairement intéressé par le produit et accepte ses modalités d'utilisation.",
    "concerned_people_status": 1,
    "rejection_reason": "Rapport incomplet",
    "applied_adjustments": "",
    "updated_at": "2018-02-21T13:21:08.054Z",
    "dpos_names": "Michael Thomas (DPO)",
    "people_names": "Les clients potentiels",
    "concerned_people_searched_opinion": true,
    "concerned_people_searched_content": "",
    "category": ""
  },
  "answers": [
    {
      "pia_id": 12,
      "reference_to": 121,
      "data": {
        "text": "Les données traitées sont les suivantes : <br />\n<ul>\n<li><strong>Données fournies par l'utilisateur</strong> :\n<ul>\n<li><strong>Données</strong>: adresse électronique, numéro de téléphone, date de naissance, genre, taille, poids ;</li>\n<li><strong>Destinataires</strong> : Dreamland, BETA, partenaires et affiliés </li>\n<li><strong>Durée de conservation</strong> : Jusqu'à la demande de suppression par l'utilisateur.<br /> </li>\n</ul>\n</li>\n<li><strong>Provenant d'applications tierces</strong> (Twitter, Facebook) obtenues par lien avec le compte DREAMLAND :\n<ul>\n<li><strong>Destinataires</strong> : Dreamland, BETA, partenaires et affiliés ;</li>\n<li><strong>Durée de conservation</strong> : Jusqu'à la demande de suppression par l'utilisateur.<br /><br /></li>\n</ul>\n</li>\n<li><strong>Données relevées</strong> :\n<ul>\n<li><strong>Données</strong>: température, humidité, taux de particules, luminosité, son/bruit, heure de réveil, données d'accéléromètre ;</li>\n<li><strong>Destinataires</strong> : Réseaux sociaux, applications tierces, Dreamland, BETA, partenaires et affiliés ;</li>\n<li><strong>Durée de conservation</strong> : Jusqu'à la demande de suppression par l'utilisateur,  les données audio sont conservées 7 jours au plus dans le buffer de la base.<br /><br /></li>\n</ul>\n</li>\n<li><strong>Données calculées</strong> :\n<ul>\n<li><strong>Données</strong>: Quantification de la qualité du sommeil, évaluation de la qualité de l'environnement de la chambre à coucher (niveau de bruit, température, humidité, air, etc.) ;</li>\n<li><strong>Destinataires</strong> : Réseaux sociaux, applications tierces, Dreamland, BETA, partenaires et affiliés ;</li>\n<li><strong>Durée de conservation</strong> : Jusqu'à la demande de suppression par l'utilisateur.<br /><br /></li>\n</ul>\n</li>\n<li><strong>Données déduites</strong> :\n<ul>\n<li><strong>Données</strong>: vie sexuelle, données philosophiques, politiques, syndicales, relatives à la religion, relatives à la santé ;</li>\n<li><strong>Destinataires</strong> : Dreamland, BETA, partenaires et affiliés ;</li>\n<li><strong>Durée de conservation</strong> : Jusqu'à la demande de suppression par l'utilisateur.</li>\n</ul>\n</li>\n</ul>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T15:33:45.958Z",
      "id": 343,
      "updated_at": "2018-02-20T15:44:04.904Z"
    },
    {
      "pia_id": 12,
      "reference_to": 122,
      "data": {
        "text": "Les données sont traitées de la façon suivante : <br />\n<ol>\n<li><strong>Création du compte utilisateur</strong> : l'utilisateur crée un compte avec ses informations personnelles ;<br /> </li>\n<li><strong>Collecte des données liées au sommeil</strong> : les capteurs Contenus dans la capsule Captoo (accrochée au matelas ou à l'oreiller) et la base (posée dans la chambre) relèvent les données qui sont visualisées sur le smartphone de l'utilisateur via une application dédiée ;<br /><br /></li>\n<li><strong>Envoie des données au serveur</strong> : les données envoyées sur un serveur, qui les analyse et produit des données calculées, qui peuvent être consultées via la même application ;<br /><br /></li>\n<li><strong>Relai des informations vers des applications tierces</strong> : les informations Captoo peuvent être relayées vers des applications tierces ou postées sur les réseaux sociaux (ex : publication de son score de sommeil) ;<br /><br /></li>\n<li><strong>Amélioration de la qualité de service</strong> : exploitation des données d'identification, relevées et calculées des utilisateurs DREAMLAND afin d'améliorer la qualité du service et d'effectuer des audits.</li>\n</ol>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T15:44:02.880Z",
      "id": 344,
      "updated_at": "2018-02-20T15:59:13.885Z"
    },
    {
      "pia_id": 12,
      "reference_to": 123,
      "data": {
        "text": "Les supports des données associés à chaque étape du cycle de vie des données sont les suivants : <br />\n<ol>\n<li><strong>Création du compte utilisateur :</strong> serveurs Cloud BETA, smartphone, applications tierces, Internet, WIFI, Bluetooth ;<br /><br /></li>\n<li><strong>Collecte des données liées au sommeil</strong> : smartphone, base Captoo, pastille Captoo, Bluetooth, Internet, WIFI ; <br /><br /></li>\n<li><strong>Envoie des données au serveur</strong> : smartphone, pastille Captoo, Bluetooth, Internet, WIFI, serveurs BETA ;<br /><br /></li>\n<li><strong>Relai des informations vers des applications tierces</strong> : smartphone, Internet, applications réseaux sociaux, applications tierces ;<br /><br /></li>\n<li><strong>Amélioration de la qualité de service</strong> : serveurs BETA.</li>\n</ol>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T15:49:13.779Z",
      "id": 345,
      "updated_at": "2018-02-20T15:59:34.843Z"
    },
    {
      "pia_id": 12,
      "reference_to": 113,
      "data": {
        "text": "Il n'y a pas de référentiels applicables.",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T16:18:19.984Z",
      "id": 346
    },
    {
      "pia_id": 12,
      "reference_to": 112,
      "data": {
        "text": "Les responsabilités sont les suivantes : <br />\n<ul>\n<li><strong>Responsable de traitement</strong> : Dreamland ; </li>\n<li><strong>Sous-traitant(s)</strong> : BETA ; </li>\n<li><strong>Destinataires</strong> : partenaires ou affiliés à Dreamland.</li>\n</ul>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T16:26:52.584Z",
      "id": 347,
      "updated_at": "2018-02-20T16:28:53.712Z"
    },
    {
      "pia_id": 12,
      "reference_to": 111,
      "data": {
        "text": "<div>Le PIA porte sur le <strong>moniteur de sommeil Captoo</strong>, produit par la société <strong>Dreamland </strong>qui est également le responsable du traitement résultant de l'utilisation de ce moniteur de sommeil. Dreamland <strong>sous-traite une partie des moyens mis en oeuvre à l'hébergeur BETA</strong>, basé aux états-Unis. </div>\n<div> </div>\n<div>Le traitement de données permettant de fournir le service est<strong> fondé sur l'exécution d'un contrat</strong> auquel l'utilisateur est partie. Captoo permet de mesurer différents éléments (données collectées pendant la nuit à l'aide de différents capteurs) pour connaître et comprendre l'environnement de l'utilisateur. <br /><br /></div>\n<div>Les principaux enjeux résident dans la création d'un nouveau service, l'identification de causes de trouble du sommeil l'amélioration de la qualité de sommeil de l'utilisateur au cours du temps.</div>\n<div> </div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T16:29:49.023Z",
      "id": 348,
      "updated_at": "2018-02-20T16:37:42.740Z"
    },
    {
      "pia_id": 12,
      "reference_to": 211,
      "data": {
        "text": "<ol>\n<li>Les données sont collectées pour <strong>fournir le service demandé par l'utilisateur</strong>, à savoir <strong>observer son sommeil</strong>, l'<strong>aider à identifier les causes de troubles</strong> et le <strong>réveiller au meilleur moment de son cycle</strong>.<br /><br /></li>\n<li>Des informations de connexion collectées par divers canaux (cookies, informations de fournisseurs internet, etc.) permettent aussi d'<strong>effectuer des statistiques d'usage</strong> sur le traitement Captoo. <br /><br /></li>\n<li>Ces données sont susceptibles d'être conservées afin <strong>d'alimenter des bases de données</strong> possédées et maintenues par DREAMLAND, ses affiliés et ses fournisseurs de service.</li>\n</ol>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T17:16:48.632Z",
      "id": 385,
      "updated_at": "2018-02-20T17:24:17.136Z"
    },
    {
      "pia_id": 12,
      "reference_to": 212,
      "data": {
        "text": "Pour chaque finalité décrite ci-dessus : <br />\n<ol>\n<li>Le traitement est nécessaire à l'<strong>exécution du contrat</strong> auquel l'utilisateur est partie ; </li>\n<li><strong>Intérêt légitime</strong> de Dreamland ;</li>\n<li><strong>Intérêt légitime</strong> de Dreamland. </li>\n</ol>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T17:23:25.768Z",
      "id": 386,
      "updated_at": "2018-02-20T17:24:45.108Z"
    },
    {
      "pia_id": 12,
      "reference_to": 213,
      "data": {
        "text": "<p><strong>Données relevées</strong> <br /><em>Température, humidité, taux de particules, luminosité, son/bruit, heure de réveil, données d'accéléromètre.</em><br />Les données sont minimisées avant leur transmission au serveur cloud de BETA et seules ces données, nécessaires à la fourniture du service, sont conservées. Les données de bruit provenant des captations audio ne sont pas enregistrées par défaut. Celles-ci sont collectées par tranches de 5 secondes et traitées dans la base Captoo pour détection de bruits caractéristiques tels que les ronflements.<br /><br /><strong>Données calculées à partir des données relevées</strong><br /><em>Quantification de la qualité du sommeil, évaluation de la qualité de l'environnement de la chambre à coucher (niveau de bruit, température, humidité, air, etc.).</em><br />Ce sont les données indicatrices de la qualité de sommeil du client livrables prévus par le contrat de service. Seules les données prévues au contrat sont calculées.<br /><br /><strong>Données courantes pour l'identification du compte</strong><br /> <em>Adresse électronique, numéro de téléphone, date de naissance, genre, taille, poids.</em><br />Données utilisées pour identifier le client et pour paramétrer les calculs de qualité de sommeil.</p>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T17:38:19.004Z",
      "id": 387,
      "updated_at": "2018-02-20T17:49:55.846Z"
    },
    {
      "pia_id": 12,
      "reference_to": 214,
      "data": {
        "text": "Les utilisateurs peuvent <strong>modifier leurs données directement identifiantes</strong> à tous moment (adresse email, taille, poids, date de naissance, etc.). Ils peuvent le faire soit <strong>via l'application</strong> soit en contactant Dreamland à l'adresse <strong>contact@captoo-dreamland.com</strong>.",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T17:40:45.892Z",
      "id": 388,
      "updated_at": "2018-02-20T17:53:09.790Z"
    },
    {
      "pia_id": 12,
      "reference_to": 215,
      "data": {
        "text": "Les données sont conservées tant que la personne concernée n'en demande pas la suppression. Celle-ci peut s'effectuer en contactant Dreamland à l'adresse<strong> contact@captoo-dreamland.com.</strong> Après la demande de suppression, <strong>les données sont rendues illisibles et les zones de stockage qui ont été utilisées sont effacées et écrasées</strong>.",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-20T17:41:35.846Z",
      "id": 389,
      "updated_at": "2018-02-20T17:54:10.288Z"
    },
    {
      "pia_id": 12,
      "reference_to": 221,
      "data": {
        "text": "L'information de l'utilisateur principal de Captoo est <strong>réalisée via les conditions générales d'utilisation</strong> (CGU). Elles sont rédigées en des termes clairs et compréhensibles et décrivent notamment :\n<ul>\n<li>la finalité du traitement (notation de la qualité de sommeil de l'utilisateur en vue de l'améliorer) ;</li>\n<li>les données personnelles collectées, aussi présentées lors de la création du compte client via l'application ; </li>\n<li>les droits de la personne concernée.</li>\n</ul>\n<div>L'utilisateur peut <strong>accéder à tout moment au CGU avec son compte client via l'application</strong>. Il peut également contacter par mail Dreamland pour toute question de confidentialité (contact@captoo-dreamland.com).</div>\n<div><br />Aucune information n'est prévue vis-à-vis des personnes tierces susceptibles d'être concernées (compagnon, enfants, autres membres du foyer, etc.).</div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:48:23.933Z",
      "id": 390,
      "updated_at": "2018-02-21T09:51:47.837Z"
    },
    {
      "pia_id": 12,
      "reference_to": 222,
      "data": {
        "text": "<div><strong>La personne accepte les CGU lors de l'installation de l'application</strong>. Elle décide également à ce moment de partager ou non ses données sur les réseaux sociaux.</div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:53:29.237Z",
      "id": 391,
      "updated_at": "2018-02-21T09:32:03.335Z"
    },
    {
      "pia_id": 12,
      "reference_to": 223,
      "data": {
        "text": "Les utilisateurs peuvent réaliser les actions suivantes via l'application smartphone :<br />\n<ul>\n<li><strong>accéder à l'ensemble de leurs données personnelles</strong> ;</li>\n<li><strong>accéder à leur historique d'utilisation</strong> ;</li>\n<li><strong>télécharger une archive de l'ensemble de leurs données personnelles</strong> ; </li>\n</ul>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:53:31.372Z",
      "id": 392,
      "updated_at": "2018-02-21T09:33:59.994Z"
    },
    {
      "pia_id": 12,
      "reference_to": 224,
      "data": {
        "text": "<div>Les données directement identifiantes (adresse email, taille, poids, date de naissance, etc.) peuvent être<strong> modifiées par l'utilisateur directement via l'application</strong>, mais la <strong>modification des données collectées ne peut se faire qu'en écrivant à contact@captoo-dreamland.com</strong>.<br /><br />Les utilisateurs peuvent<strong> effacer leurs données (en particulier en quittant le service) en écrivant à contact@captoo-dreamland.com</strong>.</div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:53:32.893Z",
      "id": 393,
      "updated_at": "2018-02-21T09:52:16.875Z"
    },
    {
      "pia_id": 12,
      "reference_to": 225,
      "data": {
        "text": "<div><strong>Les</strong> <strong>paramètres de vie privée sont accessibles à l'inscription</strong> et les utilisateurs <strong>peuvent ensuite modifier ou supprimer</strong> leurs données (en particulier en quittant le service) en écrivant à contact@captoo-dreamland.com.</div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:53:34.389Z",
      "id": 394,
      "updated_at": "2018-02-21T09:53:24.546Z"
    },
    {
      "pia_id": 12,
      "reference_to": 226,
      "data": {
        "text": "<div>Dreamland <strong>sous-traite à BETA</strong> une partie de la mise en oeuvre du traitement et de l'hébergement des données. Les serveurs de BETA se trouvent aux états-Unis.</div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:53:35.940Z",
      "id": 395,
      "updated_at": "2018-02-21T09:53:35.866Z"
    },
    {
      "pia_id": 12,
      "reference_to": 227,
      "data": {
        "text": "<div>Toutes les données sont <strong>transférées aux états-Unis dès leur collecte</strong>.</div>",
        "gauge": 0,
        "list": []
      },
      "created_at": "2018-02-21T08:53:37.484Z",
      "id": 396,
      "updated_at": "2018-02-21T09:53:46.050Z"
    },
    {
      "pia_id": 12,
      "reference_to": 321,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Discrimination",
          "Menaces",
          "Agressions",
          "Perte d'emploi",
          "Perte d'accès à des services",
          "Phishing",
          "Publicité ciblée"
        ]
      },
      "created_at": "2018-02-21T10:37:47.809Z",
      "id": 397,
      "updated_at": "2018-02-21T10:38:27.346Z"
    },
    {
      "pia_id": 12,
      "reference_to": 322,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Consultation de données",
          "Vol de données",
          "Usurpation d'un compte (via un smartphone)"
        ]
      },
      "created_at": "2018-02-21T10:38:43.038Z",
      "id": 398,
      "updated_at": "2018-02-21T10:38:56.137Z"
    },
    {
      "pia_id": 12,
      "reference_to": 323,
      "data": {
        "text": null,
        "gauge": null,
        "list": ["Employé", "Attaquant", "Entourage"]
      },
      "created_at": "2018-02-21T10:39:01.973Z",
      "id": 399,
      "updated_at": "2018-02-21T10:39:06.072Z"
    },
    {
      "pia_id": 12,
      "reference_to": 324,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Contrôle des accès logiques",
          "Chiffrement",
          "Traçabilité",
          "Supervision",
          "Organisation",
          "Surveillance",
          "Sécurité de l'exploitation"
        ]
      },
      "created_at": "2018-02-21T10:42:04.129Z",
      "id": 400,
      "updated_at": "2018-02-21T12:27:03.350Z"
    },
    {
      "pia_id": 12,
      "reference_to": 325,
      "data": {
        "text": "En cas de divulgation de leurs données, les personnes concernées pourraient connaître des <strong>conséquences significatives</strong>, qu'elles devraient pouvoir <strong>surmonter</strong>, mais avec <strong>des difficultés réelles et significatives</strong> (perte d'opportunités ciblées, sentiment d'atteinte à la vie privée, etc.).",
        "gauge": 3,
        "list": []
      },
      "created_at": "2018-02-21T11:01:54.974Z",
      "id": 401,
      "updated_at": "2018-02-21T11:04:16.109Z"
    },
    {
      "pia_id": 12,
      "reference_to": 326,
      "data": {
        "text": "Il semble <strong>extrêmement facile</strong> pour un employé, une personne de l'entourage de l'utilisateur ou un éventuel attaquant <strong>d'avoir accès aux données</strong>.",
        "gauge": 4,
        "list": []
      },
      "created_at": "2018-02-21T11:01:56.606Z",
      "id": 402,
      "updated_at": "2018-02-21T11:04:31.625Z"
    },
    {
      "pia_id": 12,
      "reference_to": 331,
      "data": {
        "text": null,
        "gauge": null,
        "list": ["Détérioration de la qualité du service"]
      },
      "created_at": "2018-02-21T12:05:51.751Z",
      "id": 403
    },
    {
      "pia_id": 12,
      "reference_to": 332,
      "data": {
        "text": null,
        "gauge": null,
        "list": ["Altération des données sur le serveur"]
      },
      "created_at": "2018-02-21T12:06:06.988Z",
      "id": 404
    },
    {
      "pia_id": 12,
      "reference_to": 333,
      "data": {
        "text": null,
        "gauge": null,
        "list": ["Employé", "Entourage", "Attaquant"]
      },
      "created_at": "2018-02-21T12:06:14.412Z",
      "id": 405,
      "updated_at": "2018-02-21T12:06:18.063Z"
    },
    {
      "pia_id": 12,
      "reference_to": 335,
      "data": {
        "text": "Les personnes concernées pourraient connaître des <strong>désagréments significatifs</strong>, qu'elles <strong>pourront surmonter malgré quelques difficultés</strong> (nécessité de refaire certains réglages, erreur dans les heures de réveil programmées, etc.).",
        "gauge": 2,
        "list": []
      },
      "created_at": "2018-02-21T12:06:27.692Z",
      "id": 406,
      "updated_at": "2018-02-21T12:07:03.118Z"
    },
    {
      "pia_id": 12,
      "reference_to": 336,
      "data": {
        "text": "Au vu du niveau de protection, il <strong>semble difficile</strong>, qu'un employé, un membre de l'entourage de l'utilisateur ou un attaquant parvienne à <strong>modifier les données d'un compte utilisateur</strong>.",
        "gauge": 2,
        "list": []
      },
      "created_at": "2018-02-21T12:06:28.908Z",
      "id": 407,
      "updated_at": "2018-02-21T12:07:24.763Z"
    },
    {
      "pia_id": 12,
      "reference_to": 341,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Nécessité de recréer un compte d'utilisation",
          "Perte de l'historique et de la personnalisation du service",
          "Détérioration de la qualité du service"
        ]
      },
      "created_at": "2018-02-21T12:08:02.405Z",
      "id": 408,
      "updated_at": "2018-02-21T12:08:30.599Z"
    },
    {
      "pia_id": 12,
      "reference_to": 342,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Suppression de données",
          "Détérioration de serveurs",
          "Dégradation physique d'un matériel"
        ]
      },
      "created_at": "2018-02-21T12:09:04.837Z",
      "id": 409,
      "updated_at": "2018-02-21T12:10:02.550Z"
    },
    {
      "pia_id": 12,
      "reference_to": 343,
      "data": {
        "text": null,
        "gauge": null,
        "list": ["Utilisateur", "Entourage", "Employé", "Attaquant", "Sinistre"]
      },
      "created_at": "2018-02-21T12:10:06.868Z",
      "id": 410,
      "updated_at": "2018-02-21T12:10:16.091Z"
    },
    {
      "pia_id": 12,
      "reference_to": 345,
      "data": {
        "text": "Les personnes concernées pourraient connaître des <strong>désagréments significatifs</strong>, qu'elles pourront <strong>surmonter malgré quelques difficultés</strong> (indisponibilité temporaire du service, probléme de réveil, etc.)",
        "gauge": 2,
        "list": []
      },
      "created_at": "2018-02-21T12:10:20.732Z",
      "id": 411,
      "updated_at": "2018-02-21T12:10:57.546Z"
    },
    {
      "pia_id": 12,
      "reference_to": 346,
      "data": {
        "text": "Il semble <strong>peu probable</strong> que les données soient durablement indisponibles, au vu de la <strong>politique de sécurité de l'hébergeur BETA</strong>.",
        "gauge": 2,
        "list": []
      },
      "created_at": "2018-02-21T12:10:23.348Z",
      "id": 412,
      "updated_at": "2018-02-21T12:12:16.064Z"
    },
    {
      "pia_id": 12,
      "reference_to": 334,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Sauvegardes",
          "Chiffrement",
          "Surveillance",
          "Contrôle des accès logiques",
          "Organisation",
          "Traçabilité",
          "Supervision",
          "Sécurité de l'exploitation"
        ]
      },
      "created_at": "2018-02-21T12:13:17.687Z",
      "id": 413,
      "updated_at": "2018-02-21T12:26:52.544Z"
    },
    {
      "pia_id": 12,
      "reference_to": 344,
      "data": {
        "text": null,
        "gauge": null,
        "list": [
          "Surveillance",
          "Sécurité des matériels",
          "Maintenance",
          "Sauvegardes",
          "Archivage",
          "Contrôle des accès logiques",
          "Organisation",
          "Traçabilité",
          "Gestion des postes de travail"
        ]
      },
      "created_at": "2018-02-21T12:16:41.044Z",
      "id": 414,
      "updated_at": "2018-02-21T12:27:46.631Z"
    }
  ],
  "measures": [
    {
      "title": "Chiffrement",
      "pia_id": 12,
      "content": "Toutes les connexions, entre la base Captoo, la pastille Captoo, le serveur cloud de BETA et le smartphone de l'utilisateur, se font en SSL via le protocole https.",
      "placeholder": "knowledge_base.slugs.PIA_TEC_CHIF.placeholder",
      "created_at": "2018-02-21T10:19:09.646Z",
      "id": 101,
      "updated_at": "2018-02-21T10:19:17.841Z"
    },
    {
      "title": "Cloisonnement des données",
      "pia_id": 12,
      "content": "La solution cloud de BETA choisie par Dreamland offre un cloisonnement vis-à-vis des données des autres clients du service",
      "placeholder": "knowledge_base.slugs.PIA_TEC_CLO.placeholder",
      "created_at": "2018-02-21T10:19:24.285Z",
      "id": 102,
      "updated_at": "2018-02-21T10:19:37.551Z"
    },
    {
      "title": "Contrôle des accès logiques",
      "pia_id": 12,
      "content": "Par identifiant et mot de passe. Il est de la responsabilité de l'utilisateur de maintenir la confidentialité de ses informations de connexion. ",
      "placeholder": "knowledge_base.slugs.PIA_TEC_CTLA.placeholder",
      "created_at": "2018-02-21T10:19:55.525Z",
      "id": 103,
      "updated_at": "2018-02-21T10:20:01.929Z"
    },
    {
      "title": "Traçabilité",
      "pia_id": 12,
      "content": "Tous les accès aux données à caractère personnel font l'objet d'une journalisation et les journaux sont audités",
      "placeholder": "knowledge_base.slugs.PIA_SEC_LOG.placeholder",
      "created_at": "2018-02-21T10:20:17.040Z",
      "id": 104,
      "updated_at": "2018-02-21T10:20:26.630Z"
    },
    {
      "title": "Contrôle d'intégrité",
      "pia_id": 12,
      "content": "Toutes les connexions, entre la base Captoo, la pastille Captoo, le serveur cloud de BETA et le smartphone de l'utilisateur, se font en SSL via le protocole https.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:20:40.100Z",
      "id": 105,
      "updated_at": "2018-02-21T10:23:03.019Z"
    },
    {
      "title": "Archivage",
      "pia_id": 12,
      "content": "Les données sont conservées tant que la personne concernée n'en demande pas la suppression. Sur demande, les données sont rendues illisibles et les zones de stockage qui ont été utilisées sont effacées et écrasées. Les données audio enregistrées (des tranches de signal de 5s) devraient à terme être conservées dans le buffer de la base Captoo, pour au plus 7 jours, afin que l'utilisateur puisse les rejouer.",
      "placeholder": "knowledge_base.slugs.PIA_TEC_ARCH.placeholder",
      "created_at": "2018-02-21T10:21:22.218Z",
      "id": 106,
      "updated_at": "2018-02-21T10:21:28.630Z"
    },
    {
      "title": "Sécurité de l'exploitation",
      "pia_id": 12,
      "content": "La maintenance des serveurs est couverte par le contrat avec BETA. La maintenance des logiciels et des terminaux est réalisée par Dreamland.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:23:13.405Z",
      "id": 107,
      "updated_at": "2018-02-21T10:52:46.953Z"
    },
    {
      "title": "Lutte contre les logiciels malveillants",
      "pia_id": 12,
      "content": "La sécurité des serveurs est couverte par le contrat avec BETA.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:23:31.068Z",
      "id": 108,
      "updated_at": "2018-02-21T10:24:08.516Z"
    },
    {
      "title": "Gestion des postes de travail",
      "pia_id": 12,
      "content": "La sécurité des postes de travail est garantie par la politique de sécurité de Dreamland.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:23:38.364Z",
      "id": 109,
      "updated_at": "2018-02-21T10:24:07.291Z"
    },
    {
      "title": "Sécurité des sites web",
      "pia_id": 12,
      "content": "Les mesures de sécurité mises en oeuvre lors de l'utilisation d'un serveur cloud de BETA sont décrites dans sa politique de sécurité.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:23:49.772Z",
      "id": 110,
      "updated_at": "2018-02-21T10:24:05.277Z"
    },
    {
      "title": "Sauvegardes",
      "pia_id": 12,
      "content": "Effectuée dans le serveur de BETA.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:25:01.272Z",
      "id": 111,
      "updated_at": "2018-02-21T10:25:09.956Z"
    },
    {
      "title": "Maintenance",
      "pia_id": 12,
      "content": "La maintenance des serveurs est couverte par le contrat avec BETA. La maintenance des logiciels et des terminaux est réalisée par Dreamland. La base Captoo et la pastille Captoo font l'objet d'une garantie d'un an.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:25:11.638Z",
      "id": 112,
      "updated_at": "2018-02-21T10:25:19.164Z"
    },
    {
      "title": "Sécurité des canaux informatiques (réseaux)",
      "pia_id": 12,
      "content": "<div>Les réseaux suivants sont mis en oeuvre : </div>\n<ul>\n<li>réseau privé du client ;</li>\n<li>Internet ;</li>\n<li>réseau privé BETA.</li>\n</ul>\n<div> </div>",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:25:20.246Z",
      "id": 113,
      "updated_at": "2018-02-21T10:25:44.170Z"
    },
    {
      "title": "Surveillance",
      "pia_id": 12,
      "content": "Les mesures de sécurité mises en oeuvre lors de l'utilisation d'un serveur cloud de BETA sont décrites dans sa politique de sécurité.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:25:48.567Z",
      "id": 114,
      "updated_at": "2018-02-21T10:25:58.642Z"
    },
    {
      "title": "Contrôle d’accès physique",
      "pia_id": 12,
      "content": "Les mesures de contrôle d'accès mises en oeuvre par BETA pour l'accès à leurs infrastructures sont décrites dans sa politique de sécurité.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:26:01.174Z",
      "id": 115,
      "updated_at": "2018-02-21T10:26:11.653Z"
    },
    {
      "title": "Sécurité des matériels",
      "pia_id": 12,
      "content": "Les mesures de sécurité physique mises en oeuvre lors de l'utilisation d'un serveur cloud de BETA sont décrites dans sa politique de sécurité. ",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:26:23.829Z",
      "id": 116,
      "updated_at": "2018-02-21T10:26:30.172Z"
    },
    {
      "title": "Éloignement des sources de risques",
      "pia_id": 12,
      "content": "La politique de sécurité de BETA mentionne l'attention portée aux risques naturels dans le choix de l'implantation de leurs datacenters.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:26:40.877Z",
      "id": 117,
      "updated_at": "2018-02-21T10:26:46.748Z"
    },
    {
      "title": "Protection contre les sources de risques non humaines",
      "pia_id": 12,
      "content": "Les mesures de sécurité physique mises en oeuvre lors de l'utilisation d'un serveur cloud de BETA sont décrites dans sa politique de sécurité (détection d'incendies, alimentation électrique, surveillance de la température, maintenance préventive, déstockage matériel, etc.).",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:26:50.350Z",
      "id": 118,
      "updated_at": "2018-02-21T10:26:57.540Z"
    },
    {
      "title": "Organisation",
      "pia_id": 12,
      "content": "L'accès des employés de Dreamland aux données à caractère personnel nécessite une autorisation.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:27:02.109Z",
      "id": 119,
      "updated_at": "2018-02-21T10:27:11.924Z"
    },
    {
      "title": "Politique (gestion des règles)",
      "pia_id": 12,
      "content": "BETA dispose d'une charte informatique.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:27:11.968Z",
      "id": 120,
      "updated_at": "2018-02-21T10:27:21.846Z"
    },
    {
      "title": "Gestion des projets",
      "pia_id": 12,
      "content": "Les tests sont effectués sur des données anonymes.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:28:59.647Z",
      "id": 122,
      "updated_at": "2018-02-21T10:29:13.324Z"
    },
    {
      "title": "Relations avec les tiers",
      "pia_id": 12,
      "content": "Les modalités d'accès aux données sont précisées dans le contrat de sous-traitance avec BETA.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:29:26.768Z",
      "id": 123,
      "updated_at": "2018-02-21T10:29:34.933Z"
    },
    {
      "title": "Supervision",
      "pia_id": 12,
      "content": "Des audits sont réalisés.",
      "placeholder": "measures.default_placeholder",
      "created_at": "2018-02-21T10:29:35.007Z",
      "id": 124,
      "updated_at": "2018-02-21T10:29:41.974Z"
    }
  ],
  "evaluations": [
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "1.2",
      "evaluation_comment": "Aucun commentaire.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T15:54:06.809Z",
      "id": 86,
      "updated_at": "2018-02-20T17:10:27.828Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "1.1",
      "evaluation_comment": "Aucun commentaire.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T17:10:31.713Z",
      "id": 87,
      "updated_at": "2018-02-20T17:10:45.970Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.1.211",
      "action_plan_comment": "Afin d'éviter un usage incompatible ou un détournement de finalité, il conviendrait d'expliciter les autres finalités dans les documents portés à la connaissance des clients et de réitérer le PIA pour ces traitements. L'enjeu pour la vie privée des personnes diffère en fonction des finalités.",
      "evaluation_comment": "Cette finalité doit être distinguée de celle des transmissions de données aux affiliés ou de tout autre traitement à des fins de recherche ou d'éventuel profilage mis en oeuvre par BETA et ses affiliés. Ces autres finalités sont rapidement évoquées, sans pour autant être explicite.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T18:00:01.053Z",
      "id": 88,
      "updated_at": "2018-02-21T13:06:12.045Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.1.212",
      "action_plan_comment": "Distinguer le service lui-même des autres finalités, au besoin faire un PIA pour chacune.",
      "evaluation_comment": "Ce fondement n'est valable que pour le traitement de données strictement nécessaire à la fourniture du service. Il ne sera pas valable pour la transmission de données à des tiers ou toute autre finalité de traitement accessoire, non nécessaire pour fournir le service.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T18:00:01.057Z",
      "id": 89,
      "updated_at": "2018-02-21T13:06:12.048Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.1.213",
      "action_plan_comment": "<div>Une distinction entre les données absolument nécessaires au fonctionnement du moniteur et de l'application et celles non nécessaires doit être faite.</div>\n<div> </div>\n<div>La captation du son doit être supprimée et remplacée par le suivi du niveau sonore (en dB) au cours de la nuit.</div>\n<div> </div>",
      "evaluation_comment": "<div>La nécessité de la collecte de certaines données (informations personnelles comme la localisation, la date de naissance, l'âge, le poids, etc.) pour l'évaluation de la qualité du sommeil de l'utilisateur semble questionnable. Pour la localisation, il s'agirait de pouvoir intégrer les heures de lever et coucher du soleil ainsi que des informations d'ordre météorologique. <br /><br /></div>\n<div>Il n'y a aucune garantie que les données agrégées pour partage avec des applications tierces soient effectivement anonymes (cf. remarques ci-dessus sur les finalités autres que le bon fonctionnement du service).</div>\n<div> </div>",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T18:00:01.061Z",
      "id": 90,
      "updated_at": "2018-02-21T13:06:12.052Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "2.1.214",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T18:00:01.065Z",
      "id": 91,
      "updated_at": "2018-02-21T13:06:12.055Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.1.215",
      "action_plan_comment": "Une durée de conservation pour chaque catégorie de donnée doit être fixée en tenant compte de ce qui est strictement nécessaire au bon fonctionnement du service. Pour que la procédure d'effacement soit efficace, BETA doit distinguer entre les données présentes dans ses serveurs, celles présentes dans les serveurs de son sous-traitant et celles traitées en local dans le moniteur et le téléphone de l'utilisateur.",
      "evaluation_comment": "Aucune durée de conservation n'est fixée, les données peuvent donc être stockées indéfiniment dans les serveurs, à défaut de demande de suppression de l'utilisateur.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-20T18:00:01.072Z",
      "id": 92,
      "updated_at": "2018-02-21T13:06:12.059Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.221",
      "action_plan_comment": "<div>Afin d'assurer la transparence et la pleine connaissance des conséquences de l'usage de l'application, Dreamland pourrait informer ses utilisateurs sous forme de pop up lors de l'activation de l'application, de manière concise, en des termes simples et clairs, et par l'utilisation d'icônes, de l'identité et des coordonnées du responsable de traitement, des finalités de chaque traitement et de tout traitement ultérieur, de leur base juridique respective, des destinataires des données (la mention de partenaires et affiliés est trop large), de la durée de conservation, de la manière d'exercer les droits d'accès, de rectification, d'opposition, d'effacement, le droit à la portabilité, le droit à la limitation du traitement, les coordonnées du délégué à la protection des données (s'il a été nommé).<br /><br /></div>\n<div>Une information sur le transfert de données hors UE est requise.</div>\n<div> </div>",
      "evaluation_comment": "Placer l'information dans les CGU risque de la noyer parmi d'autres aspects. L'information n'est pas complète s'agissant des aspects décrits dans les mesures correctives ci-dessous.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.027Z",
      "id": 93,
      "updated_at": "2018-02-21T13:13:55.881Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.222",
      "action_plan_comment": "Afin d'éviter un usage incompatible ou un détournement de finalité, il conviendrait d'expliciter les autres finalités dans les documents portés à la connaissance des clients et de réitérer le PIA pour ces traitements. L'enjeu pour la vie privée des personnes diffère en fonction des finalités.",
      "evaluation_comment": "Le traitement est basé sur un contrat, mais il est nécessaire d'expliciter les sous finalités. ",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.033Z",
      "id": 94,
      "updated_at": "2018-02-21T13:13:55.885Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.223",
      "action_plan_comment": "<div>Identifier les données soumises à portabilité et définir le format structuré couramment utilisé et lisible par une machine permettant d'automatiser leur transmission. </div>\n<div> </div>\n<div>S'assurer de la complétude des informations fournies depuis les différents supports de données, lors de la réponse à une demande d'exercice du droit d'accès.</div>\n<div> </div>",
      "evaluation_comment": "<div>Les données accessibles depuis l'application ne sont pas les seules données détenues par Dreamland. Celles-ci peuvent comprendre les données de connexion (IP, horodatage des connexions au service et.) collectées dans le cadre du fonctionnement du service, un éventuel profil restitué de manière incomplète par l'appli, etc. L'utilisateur doit être en mesure de les récupérer que ce soit, dans leur intégralité, par son droit d'accès, ou partiellement en demandant une portabilité (le service étant fourni sur la base d'un contrat).</div>\n<div> </div>",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.038Z",
      "id": 95,
      "updated_at": "2018-02-21T13:13:55.889Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.224",
      "action_plan_comment": "<div>A chaque évolution du service et de ses sous-finalités, Dreamland devrait initier une procédure de révision de la pertinence des données collectées pour signaler, au moyen d'une icône, les données qui ne sont plus absolument nécessaires à l'exécution du service et dont la personne peut demander l'effacement, si Dreamland ne l'a pas déjà fait. <br /><br /></div>\n<div>Un accusé de réception devrait être adressé pour confirmer la prise en compte des demandes. Un message de sensibilisation pourrait également être envoyé à l'utilisateur pour l'inviter à avertir son entourage de l'activation de l'application.</div>\n<div> </div>",
      "evaluation_comment": "<div>Les utilisateurs peuvent rectifier leurs données (informations sur l'utilisateur, mais pas les données collectées à l'aide de capteurs) et demander la suppression des informations, mais sans savoir sur quelles données portent précisément ce droit. De plus l'entourage de l'utilisateur susceptible d'être concerné par les données collectées ne peut s'opposer au système.</div>\n<div> </div>",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.042Z",
      "id": 96,
      "updated_at": "2018-02-21T13:13:55.895Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.225",
      "action_plan_comment": "Les suites à donner à l'identification d'un problème de licéité, d'exactitude des données, de pertinence, etc. doivent être documentées et permettre de répondre à chaque demande de limitation du traitement.",
      "evaluation_comment": "<div>Attention, dans le cas présent, la seule finalité étudiée est celle de la fourniture du service basé sur l'exécution du contrat ; les données collectées sur la base de ce fondement ne font pas l'objet du droit d'opposition prévu à l'article 21 du RGPD. </div>\n<div> </div>\n<div>Le droit à la limitation du traitement permettra en revanche à la personne concernée de signaler un problème au niveau du traitement de ses données et à Dreamland de suspendre leur traitement le temps de vérifier le bien-fondé de la demande (par exemple).</div>",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.045Z",
      "id": 97,
      "updated_at": "2018-02-21T13:13:55.899Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.226",
      "action_plan_comment": "Un contrat de sous-traitance doit être conclu entre les 2 sociétés précisant l'ensemble des éléments prévus à l'art. 28 (durée, périmètre, finalité, des instructions de traitement documentées, l'autorisation préalable en cas de recours à un sous-traitant, mise à disposition de toute documentation apportant la preuve du respect du règlement, notification immédiate de toute violation de données, etc.).",
      "evaluation_comment": "BETA agissant en tant que sous-traitant, elle ne peut traiter les données que selon les instructions et pour le compte de Dreamland, dans un cadre établi par écrit.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.049Z",
      "id": 98,
      "updated_at": "2018-02-21T13:13:55.902Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "2.2.227",
      "action_plan_comment": "<div>Dreamland doit s'assurer d'encadrer le transfert par des garanties appropriées (cf. liste d'instrument art. 46). Il sera également nécessaire de signer un contrat avec ce sous-traitant aux US.  </div>",
      "evaluation_comment": "Aucun encadrement du transfert des données collectées depuis les moniteurs vers les serveurs de l'hébergeur aux états-Unis ne semble être prévu.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T09:53:51.053Z",
      "id": 99,
      "updated_at": "2018-02-21T13:13:55.906Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.4",
      "evaluation_comment": "<div>Un utilisateur voit les données relatives à son sommeil supprimées par maladresse par un employé de Dreamland et perd ainsi tout l'historique d'utilisation et de personnalisation du service. Le risque semble acceptable au regard de la gravité (limitée) et de la vraisemblance (limitée) résiduelles, compte tenu des mesures existantes ou prévues.</div>\n<div> </div>",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:28:25.424Z",
      "id": 120,
      "updated_at": "2018-02-21T12:59:59.633Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.3",
      "evaluation_comment": "<div>Un utilisateur peut voir ses données de sommeil faussées suite à l'hébergement d'une personne dans sa chambre à coucher et observer une détérioration de la qualité du service. Le risque semble acceptable au regard de la gravité (limitée) et de la vraisemblance (limitée) résiduelles, compte tenu des mesures existantes ou prévues.<br /><br />En bonne pratique, il serait important d'ajouter la mesure <strong>gestion des incidents et des violations de données ; </strong>aidant à traiter le risque.</div>\n<div> </div>",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:28:35.167Z",
      "id": 121,
      "updated_at": "2018-02-21T13:00:20.761Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.2",
      "action_plan_comment": "Les mesures correctives suivantes doivent être mises en oeuvre :<br />\n<ul>\n<li>Préciser, et le cas échéant adapter, la manière dont les enregistrements audio sont réalisés, sauvegardés et restitués aux utilisateurs ;</li>\n<li>mettre en oeuvre des mesures de chiffrement des données stockées en base ;</li>\n<li>préciser à l'utilisateur les bonnes pratiques à suivre lors de la mise au rebut des matériels ;</li>\n<li>mettre en place une charte d'utilisation des moyens informatiques et un engagement de confidentialité pour les employés de Dreamland.</li>\n</ul>\n<div>Ajouter la mesure ; <strong>gestion des incidents et des violations de données</strong>.</div>",
      "evaluation_comment": "Des données pourraient encore être volées par un employé de Dreamland, ou consultées par l'entourage usurpant le compte via le smartphone dans le but de caractériser une situation relevant de la vie privée des personnes (par exemple un adultère).",
      "gauges": { "x": 3, "y": 1 },
      "estimated_implementation_date": null,
      "person_in_charge": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:28:38.351Z",
      "id": 122,
      "updated_at": "2018-02-21T13:00:56.885Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.101",
      "action_plan_comment": "TLS devrait être employé pour l'utilisation du protocole https.",
      "evaluation_comment": "Il est recommandé d'utiliser la version de TLS la plus à jour possible et non SSL.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.071Z",
      "id": 123,
      "updated_at": "2018-02-21T13:00:29.358Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.102",
      "action_plan_comment": "Il conviendrait de préciser la manière dont les données sont cloisonnées.",
      "evaluation_comment": "Il n'est pas indiqué si les données des utilisateurs sont isolées entre elles dans les serveurs utilisés par Captoo. Par ailleurs, il n'est pas précisé si les instances sur lesquels les serveurs s'exécutent sont dédiés (ce qui est vraisemblable) ou si ces instances sont susceptibles d'être réutilisées par des tiers.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.082Z",
      "id": 124,
      "updated_at": "2018-02-21T13:00:29.367Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.103",
      "action_plan_comment": "Il conviendrait de préciser la politique de gestion des mots de passe.",
      "evaluation_comment": "Il incombe toutefois à Dreamland de garantir la bonne gestion de ces informations.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.093Z",
      "id": 125,
      "updated_at": "2018-02-21T13:00:29.377Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.104",
      "action_plan_comment": "Il conviendrait de préciser les informations journalisées, leurs durées de conservation, l'architecture de journalisation, la fréquence et la procédure d'audit des journaux, et si des procédures de détection des accès frauduleux et/ou suspects sont mises en oeuvre. <strong>Une nouvelle mesure gestion des incidents et des violations de données doit être ajoutée au traitement </strong>pour mettre en place une procédure de gestion des violations des données personnelles.",
      "evaluation_comment": "Manque de précision.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.103Z",
      "id": 126,
      "updated_at": "2018-02-21T13:00:29.390Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.105",
      "action_plan_comment": "Chaque modification pourrait être horodatée et la date de dernière modification conservée dans l'application pour être vérifiée à la reconnexion. En cas de différence l'utilisateur recevrait une alerte.",
      "evaluation_comment": "Les données pourraient être altérées après leur transfert.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.126Z",
      "id": 127,
      "updated_at": "2018-02-21T13:00:29.398Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.106",
      "action_plan_comment": "Une durée de conservation pour chaque catégorie de donnée doit être fixée en tenant compte de ce qui est strictement nécessaire au bon fonctionnement du service. Pour que la procédure d'effacement soit efficace, Dreamland doit distinguer entre les données présentes dans ses serveurs, celles présentes dans les serveurs de son sous-traitant et celles traitées en local dans le moniteur et le téléphone de l'utilisateur.",
      "evaluation_comment": "Aucune durée de conservation n'est fixée, les données peuvent donc être stockées indéfiniment dans les serveurs, à défaut de demande de suppression de l'utilisateur.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.141Z",
      "id": 128,
      "updated_at": "2018-02-21T13:00:29.406Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.107",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.157Z",
      "id": 129,
      "updated_at": "2018-02-21T13:00:29.416Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.108",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.173Z",
      "id": 130,
      "updated_at": "2018-02-21T13:00:29.425Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.109",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.188Z",
      "id": 131,
      "updated_at": "2018-02-21T13:00:29.433Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.110",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.199Z",
      "id": 132,
      "updated_at": "2018-02-21T13:00:29.441Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.111",
      "action_plan_comment": "Préciser la politique de sauvegarde de BETA.",
      "evaluation_comment": "Manque de précision.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.215Z",
      "id": 133,
      "updated_at": "2018-02-21T13:00:29.451Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.112",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.228Z",
      "id": 134,
      "updated_at": "2018-02-21T13:00:29.459Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.113",
      "action_plan_comment": "Rappeler les bonnes pratiques concernant les réseaux domestiques dans la documentation produit.",
      "evaluation_comment": "Le réseau privé du client est à sa charge, toutefois un rappel des bonnes pratiques de sécurité pourrait être fait.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.238Z",
      "id": 135,
      "updated_at": "2018-02-21T13:00:29.473Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.114",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.248Z",
      "id": 136,
      "updated_at": "2018-02-21T13:00:29.482Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.115",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.259Z",
      "id": 137,
      "updated_at": "2018-02-21T13:00:29.490Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.116",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.269Z",
      "id": 138,
      "updated_at": "2018-02-21T13:00:29.499Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.117",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.279Z",
      "id": 139,
      "updated_at": "2018-02-21T13:00:29.507Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.118",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.296Z",
      "id": 140,
      "updated_at": "2018-02-21T13:00:29.516Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.119",
      "action_plan_comment": "Il conviendrait de préciser la manière dont les habilitations sont gérées. <strong>Une nouvelle mesure gestion des personnels doit être ajoutée au traitement </strong>afin de prévoir des sessions de sensibilisation du personnel et de préciser les mesures prises en cas de départ d'un salarié dans la procédure de gestion du personnel. \n<div> </div>\n<div> </div>",
      "evaluation_comment": "Manque de précision.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.311Z",
      "id": 141,
      "updated_at": "2018-02-21T13:00:29.524Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.120",
      "action_plan_comment": "Dreamland devrait en rédiger une également.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.326Z",
      "id": 142,
      "updated_at": "2018-02-21T13:00:29.535Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.122",
      "action_plan_comment": "<strong>Une nouvelle mesure complémentaire gestion des risques doit être ajoutée au traitement </strong>pour mettre en place une procédure de gestion de projet intégrant l'étude systématique des risques que font peser le traitement sur la vie privée des personnes concernées.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.338Z",
      "id": 143,
      "updated_at": "2018-02-21T13:00:29.544Z"
    },
    {
      "status": 3,
      "pia_id": 12,
      "reference_to": "3.1.123",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.351Z",
      "id": 144,
      "updated_at": "2018-02-21T13:00:29.552Z"
    },
    {
      "status": 2,
      "pia_id": 12,
      "reference_to": "3.1.124",
      "action_plan_comment": "Il conviendrait de préciser les conditions de réalisation des audits internes.",
      "evaluation_comment": "Manque de précision.",
      "gauges": { "x": 0, "y": 0 },
      "estimated_implementation_date": null,
      "global_status": 2,
      "created_at": "2018-02-21T12:29:07.366Z",
      "id": 145,
      "updated_at": "2018-02-21T13:00:29.561Z"
    }
  ],
  "comments": [
    {
      "description": "Le fondement juridique correspondant à l’exécution du contrat ne sera valable que pour la fourniture du service demandé par l’utilisateur et non pour le calculer des statistiques ou alimenter les bases de données des affiliés et fournisseurs de service de Dreamland. \n\nPour chacune des finalités, calcul de statistiques et alimentation des bases des affiliés et fournisseurs, correspondant chacune à la notion de « traitement », il conviendra de refaire un PIA et d’évaluer la possibilité de recourir à l’intérêt légitime en fonction des mesures de protection mises en place.\n",
      "pia_id": 12,
      "reference_to": 212,
      "for_measure": false,
      "created_at": "2018-02-21T13:21:35.620Z",
      "id": 1
    }
  ]
}
